import './health-professional-button.scss';

import { MouseEvent, useCallback } from 'react';

import {
  HealthProfessionalItemDataFragment,
  UserItemFragment,
} from '../../data/types/api/graphql';
import { useFormatters } from '../../data/utils/formatters.utils';
import { Avatar } from '../../elements/avatar/avatar/avatar';
import { CustomFormattedMessage } from '../../elements/intl/custom-formatted-message';

type HealthProfessionalButtonProps = {
  testId?: string;
  healthProfessional?:
    | UserItemFragment
    | HealthProfessionalItemDataFragment
    | null
    | undefined;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
};

export function HealthProfessionalButton({
  testId = 'health-professional',
  healthProfessional,
  onClick,
}: HealthProfessionalButtonProps) {
  const getTestId = useCallback(
    (value: string | null = null) =>
      [testId, 'button', value].filter(option => option).join('.'),
    [testId]
  );

  const onHandleClick = useCallback(
    (e: MouseEvent<HTMLElement>) => {
      e.preventDefault();
      e.stopPropagation();

      onClick?.(e);
    },
    [onClick]
  );

  const { getFullName } = useFormatters();

  return (
    <button
      data-test-id={getTestId()}
      type="button"
      className="button button--health-professional"
      onClick={onHandleClick}
    >
      {healthProfessional ? (
        <>
          <Avatar text={healthProfessional.initials ?? ""} />
          <span data-test-id={getTestId('text')}>
            {getFullName(healthProfessional)}
          </span>
        </>
      ) : (
        <span data-test-id={getTestId('text')}>
          <CustomFormattedMessage id="common.no-health-professional" />
        </span>
      )}
    </button>
  );
}
